import React from 'react';
import {Link,useLocation} from 'react-router-dom';
import {useGuideAccess} from '../guide-authoring/useGuideAuthoring';
import './StratsPlanner.css';
import './GuideHubNavigation.css';
export default function GuideHubNavigation(){
 const {pathname}=useLocation(),{staff}=useGuideAccess();
 return <nav className="SP__navigation" aria-label="Guide pages"><div>
  <Link to="/strats-planner" aria-current={pathname.startsWith('/strats-planner')?'page':undefined}>My Playbooks</Link>
  <Link to="/guide-library" aria-current={pathname==='/guide-library'?'page':undefined}>Guide Library</Link>
  {staff&&!window.desktopAPI&&<Link to="/guide-admin" aria-current={pathname.startsWith('/guide-admin')?'page':undefined}>Admin Guide</Link>}
 </div></nav>;
}
